// extracted by mini-css-extract-plugin
module.exports =  {"generate-brief-container":"mBcYyBH","generateBriefContainer":"mBcYyBH","ai-image-text":"VL23Ay5","aiImageText":"VL23Ay5","question":"xFKEDAg","cta":"BLFpfF2"};